/** Small helpers for per-route head tags (title, meta, canonical, JSON-LD). */

export const upsertMeta = (kind: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${kind}="${key}"]`);
  const created = !el;
  const prev = el?.getAttribute("content") ?? "";
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(kind, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return () => {
    if (created) el?.remove();
    else el?.setAttribute("content", prev);
  };
};

export const upsertCanonical = (href: string) => {
  const el = document.querySelector('link[rel="canonical"]');
  const prev = el?.getAttribute("href") ?? "";
  el?.setAttribute("href", href);
  return () => {
    if (el) el.setAttribute("href", prev);
  };
};

export const upsertLdJson = (id: string, data: unknown) => {
  let el = document.getElementById(id) as HTMLScriptElement | null;
  const created = !el;
  const prev = el?.textContent ?? "";
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
  return () => {
    if (created) el?.remove();
    else if (el) el.textContent = prev;
  };
};